import React, {Component} from 'react';
import Api from '../../utils/Api';
import PropTypes from 'prop-types';
import TableContainer from '../../utils/TableContainer';
import 'react-confirm-alert/src/react-confirm-alert.css';
import '../../css/style-confirmAlert.css';
import {confirmAlert} from 'react-confirm-alert';

class SetupShifts extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    static defaultProps = {
        onClick: () => {},
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            editParams: {
                id: null,
                name: null,
                from: null,
                to: null,
            },
            addParams: {
                name: '',
                from: '00:00',
                to: '00:00',
            },
        };

        this.translate = this.props.baseData.translate;

        //  Update input fields with onChange.
        this.setEditShiftInput = this.setEditShiftInput.bind(this);
        this.setAddShiftInput = this.setAddShiftInput.bind(this);

        //  Select row for editing.
        this.editShift = this.editShift.bind(this);

        //  Update existing row.
        this.enterUpdateShift = this.enterUpdateShift.bind(this);
        this.updateShift = this.updateShift.bind(this);

        //  Cancel editing row.
        this.enterCancelShift = this.enterCancelShift.bind(this);
        this.cancelShift = this.cancelShift.bind(this);

        //  Delete row.
        this.deleteShift = this.deleteShift.bind(this);

        //  Add new row.
        this.enterAddShift = this.enterAddShift.bind(this);
        this.addShift = this.addShift.bind(this);

        //  Clear add-input flieds.
        this.clearAddShift = this.clearAddShift.bind(this);

    }

    moveCursorToEnd(field) {


        const temp_value = field.target.value;

        field.target.value = '';
        field.target.value = temp_value;

    }

    setEditShiftInput(event, id, key) {

        //  Copy object.
        const newInput = {...this.state.editParams};

        newInput[key] = event.target.value;

        this.setState({
            editParams: newInput
        });

    }

    setAddShiftInput(event, key) {

        //  Copy object.
        const newInput = {...this.state.addParams};

        newInput[key] = event.target.value;

        this.setState({
            addParams: newInput
        });

    }

    editShift(row) {

        const editRow = {...row};

        if (editRow['from'].split(':').length === 3) editRow['from'] = editRow['from'].slice(0, -3);
        if (editRow['to'].split(':').length === 3) editRow['to'] = editRow['to'].slice(0, -3);

        this.setState({
            editParams: editRow,
        });

    }

    enterUpdateShift(event) {

        if (event.keyCode === 13) {
            this.updateShift();
        } else if (event.keyCode === 27) {
            this.cancelShift();
        }

    }

    updateShift() {

        const row = this.state.editParams;

        if (row && row.id) {
            const params = {
                'action': 'save',
                'id': row.id,
                'name': row.name,
                'from': row.from,
                'to': row.to,
            };

            const callback = function (res) {
                if (res) this.props.requestShifts();

                this.cancelShift();
            }.bind(this);

            this.api.request('SaveWorkPeriod', params, callback, null);
        }

    }

    enterCancelShift(event) {

        if (event.keyCode === 13 || event.keyCode === 27) this.cancelShift();

    }

    cancelShift() {

        this.setState({
            editParams: {
                id: null,
                name: null,
                from: null,
                to: null,
            },
        });

    }

    deleteShift(row) {

        confirmAlert({
            title:  this.translate('deleteShift'),
            message: <div>
                <p>Are you sure you want to delete this shift?</p>
                <p>"{row.name}"</p>
            </div>,
            buttons: [
                {
                    label: this.translate('yes'),
                    onClick: () => {
                        if (row && row.id) {
                            const params = {
                                'action': 'delete',
                                'id': row.id,
                            };

                            const callback = function (res) {
                                if (res) this.props.requestShifts();
                            }.bind(this);

                            this.api.request('SaveWorkPeriod', params, callback, null);
                        }
                    }
                },
                {
                    label: this.translate('no'),
                }
            ]
        });

    }

    enterAddShift(event) {

        if (event.keyCode === 13) {
            this.addShift();
        } else if (event.keyCode === 27) {
            this.clearAddShift();
        }

    }

    addShift() {

        if (this.state.addParams.name && this.state.addParams.from && this.state.addParams.to) {
            const params = {
                'action': 'add',
                'companyId': this.props.baseData.companies.currentCompany.id,
                'name': this.state.addParams.name,
                'from': (this.state.addParams.from.split(':').length === 3) ? this.state.addParams.from : this.state.addParams.from + ':00',
                'to': (this.state.addParams.to.split(':').length === 3) ? this.state.addParams.to : this.state.addParams.to + ':00',
            };

            const callback = function (res) {
                if (res) {
                    this.props.requestShifts();

                    this.clearAddShift();
                }
            }.bind(this);

            this.api.request('SaveWorkPeriod', params, callback, null);
        }

    }

    clearAddShift() {

        this.setState({
            addParams: {
                name: '',
                from: '00:00',
                to: '00:00',
            },
        });

    }

    getTableColumns() {

        return [
            {
                key: 'name',
                nameKey: 'name',
            },
            {
                key: 'from',
                nameKey: 'from',
            },
            {
                key: 'to',
                nameKey: 'to',
            },
            {
                key: 'options',
                nameKey: 'options',
            },
        ];

    }

    getTableRows() {

        const data = (this.props.baseData.shifts.shifts) ? this.props.baseData.shifts.shifts : [];
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];

            if (this.state.editParams && this.state.editParams.id === rowTemp.id) {
                rows.push({
                    id: rowTemp.id,
                    name: <input tabIndex="1" name="name" type="text" value={this.state.editParams.name} autoFocus={true} onFocus={(event) => this.moveCursorToEnd(event)} onChange={(event) => this.setEditShiftInput(event, rowTemp.id, 'name')} onKeyDown={(event) => this.enterUpdateShift(event)} />,
                    from: <input tabIndex="2" name="from" type="time" step="60" value={this.state.editParams.from} onChange={(event) => this.setEditShiftInput(event, rowTemp.id, 'from')} onKeyDown={(event) => this.enterUpdateShift(event)} />,
                    to: <input tabIndex="3" name="to" type="time" step="60" value={this.state.editParams.to} onChange={(event) => this.setEditShiftInput(event, rowTemp.id, 'to')} onKeyDown={(event) => this.enterUpdateShift(event)} />,
                    options: <div className="tableOptions">
                        <a tabIndex="4" className="optionSave" onClick={this.updateShift} onKeyDown={(event) => this.enterUpdateShift(event)} title={this.translate('save')}>&nbsp;</a>
                        <a tabIndex="5" className="optionCancel" onClick={this.cancelShift} onKeyDown={(event) => this.enterCancelShift(event)} title={this.translate('cancel')}>&nbsp;</a>
                    </div>,
                });
            } else {
                rows.push({
                    id: rowTemp.id,
                    name: rowTemp.name,
                    from: (rowTemp.from.split(':').length === 3) ? rowTemp.from.slice(0, -3) : rowTemp.from,
                    to: (rowTemp.to.split(':').length === 3) ? rowTemp.to.slice(0, -3) : rowTemp.to,
                    options: <div className="tableOptions">
                        <a className="optionEdit" onClick={() => this.editShift(rowTemp)} title={this.translate('edit')}>&nbsp;</a>
                        <a className="optionDelete" onClick={() => this.deleteShift(rowTemp)} title={this.translate('delete')}>&nbsp;</a>
                    </div>,
                });
            }
        }

        rows.push({
            id: 0,
            name: <input tabIndex="11" name="name" type="text" onChange={(event) => this.setAddShiftInput(event, 'name')} />,
            from: <input tabIndex="12" name="from" type="time" step="60" value={this.state.addParams.from} onChange={(event) => this.setAddShiftInput(event, 'from')} />,
            to: <input tabIndex="13" name="to" type="time" step="60" value={this.state.addParams.to} onChange={(event) => this.setAddShiftInput(event, 'to')} />,
            options: <div className="tableOptions">
                <a tabIndex="14" className="optionAdd" onClick={this.addShift} onKeyDown={(event) => this.enterAddShift(event)} title={this.translate('add')}>&nbsp;</a>
            </div>,
        });

        return rows;

    }

    render() {

        const tableColumns = this.getTableColumns();
        const tableRows = this.getTableRows();

        return (
            <div>
                <nav>
                    <h1>{this.translate('setupHeader3')}</h1>
                </nav>

                <div>
                    <p>{this.translate('setupText3')}</p>
                </div>

                <TableContainer
                    baseData={this.props.baseData}
                    columns={tableColumns}
                    rows={tableRows}
                    fillGaps="-"
                    maxWidth={750}
                />
            </div>
        );

    }

}

export default SetupShifts;